import React from 'react';
import { Alert, Grow, Box, Button, Typography, Stack, useMediaQuery, useTheme } from '@mui/material';
import { PersonAdd, Login } from '@mui/icons-material';

function AuthPrompt({ isAuthenticated }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  if (isAuthenticated) return null;

  return (
    <Grow in timeout={600}>
      <Alert
        severity="info"
        icon={false} // remove leading icon gap on mobile
        variant="outlined"
        sx={{
          mb: { xs: 2, sm: 4 },
          p: { xs: 1.25, sm: 2.25 },
          borderRadius: { xs: 2, sm: 4 },
          background: {
            xs: 'rgba(33,150,243,0.04)',
            sm: 'linear-gradient(135deg, rgba(33,150,243,0.08) 0%, rgba(33,150,243,0.03) 100%)'
          },
          border: '1px solid rgba(33,150,243,0.25)',
          // Make the message/action areas tight on xs
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'space-between',
            gap: { xs: 1, sm: 1.5 }
          },
          '& .MuiAlert-action': {
            m: 0,
            p: 0,
            alignSelf: { xs: 'stretch', sm: 'center' }
          }
        }}
        action={
          <Stack
            direction="row"
            spacing={1}
            sx={{
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'flex-end', sm: 'flex-end' },
            }}
          >
            <Button
              href="/register"
              size="small"
              variant="contained"
              disableElevation
              startIcon={!isXs ? <PersonAdd /> : null}
              sx={{
                fontWeight: 700,
                textTransform: 'none',
                fontSize: { xs: '0.72rem', sm: '0.875rem' },
                px: { xs: 1.25, sm: 2 },
                py: { xs: 0.4, sm: 0.7 },
                minWidth: { xs: 'auto', sm: 84 },
              }}
            >
              Join
            </Button>
            <Button
              href="/login"
              size="small"
              variant="outlined"
              startIcon={!isXs ? <Login /> : null}
              sx={{
                fontWeight: 700,
                textTransform: 'none',
                fontSize: { xs: '0.72rem', sm: '0.875rem' },
                px: { xs: 1.25, sm: 2 },
                py: { xs: 0.4, sm: 0.7 },
                minWidth: { xs: 'auto', sm: 84 },
              }}
            >
              Login
            </Button>
          </Stack>
        }
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight={800}
            sx={{
              mb: 0.5,
              fontSize: { xs: '0.98rem', sm: '1.15rem', md: '1.3rem' },
              lineHeight: 1.2,
            }}
          >
            🚀 Join the mission
          </Typography>

          <Typography
            component="div"
            sx={{
              fontSize: { xs: '0.78rem', sm: '0.9rem' },
              lineHeight: { xs: 1.35, sm: 1.5 },
              color: 'text.secondary',
            }}
          >
            Create a free account to compete in leaderboards, earn rewards, and track your environmental impact!
            {/* Hide the second sentence on very small screens */}
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
              {' '}Join thousands of eco warriors making Bangladesh greener.
            </Box>
          </Typography>
        </Box>
      </Alert>
    </Grow>
  );
}

export default AuthPrompt;
